import { DatePicker, Form, Input, message, Spin, Table } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import GridBuilder from 'UIBuilderEngine/GridBuilder';
import { getDeclarationJson } from './DeclarationJSON';
import styled from 'styled-components';
import { ButtonFilled } from 'reusableComponent/UIButtons';
import { CALL_API } from 'common/API';
import { STATUS_CODE } from 'common/Constants';
import moment from 'moment';
import queryKeys from 'common/queryKey';
import { useFetch } from 'hooks/useFetch';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import { getClientid, getUserInfo } from 'redux/selectors';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as html2pdf from "html2pdf.js";
import userlogo from "../../assets/dubailogo.svg";

const StyledDeclaration = styled.div`
.ant-form-item-label > label{
    position: relative;
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 100% !important; 
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
}
    .styled-text{
    font: normal normal normal 20px/35px Pacifico;
    }
  .avoid-break {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    display: contents;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
}
    .table-wrapper {
    width: 100%;
    overflow-x: auto;
  }
  .table-wrapper table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
  }
  .table-wrapper th,
  .table-wrapper td {
    text-align: left;
    padding: 8px;
    word-wrap: break-word;
    border: 1px solid #f0f0f0;
  }
  .table-wrapper th:nth-child(1),
  .table-wrapper td:nth-child(1) {
    width: 50%;
  }
  .table-wrapper th:nth-child(2),
  .table-wrapper td:nth-child(2) {
    width: 50%;
  }
`

const Declaration = ({ filteruser, type = "" }) => {

  const [form] = Form.useForm();
  const containerRef = useRef()
  const [clientName, setClientName] = useState("");
  const [natureOfRelationship, setNatureOfRelationship] = useState("");
  const [loading, setLoading] = useState(false)
  const [typeBtn, setTypeBtn] = useState("")
  const clientId = useSelector(getClientid)
  const [data, setData] = useState({});
  let initialDate = moment().startOf('year');
  const [year, setYear] = useState(initialDate ? moment(initialDate).format("YYYY") : null);
  const [selectedYear, setSelectedYear] = useState();
  const [loader, setLoader] = useState(false);
  const [submitbtnLoader, setsubmitbtnLoader] = useState(false);
  const [isPrint, setIsPrint] = useState(false);

  const printComponentRef = React.useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  const handlePrint = async () => {
    setIsDownloading(true);
    const element = printComponentRef.current;
    if (!element) {
      setIsDownloading(false);
      return;
    }

    const svgImg = new Image();
    svgImg.src = userlogo;
    await new Promise((res) => (svgImg.onload = res));
    const canvas = document.createElement("canvas");
    canvas.width = svgImg.width;
    canvas.height = svgImg.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(svgImg, 0, 0);
    const logoPngData = canvas.toDataURL("image/png");

    const headerBandHeight = 1;
    const gapBelowHeader = 0.25;
    const opt = {
      margin: [
        headerBandHeight + gapBelowHeader,
        0.5
      ],
      filename: "Declaration.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();

        const headerHeight = 1;
        const logoW = 1;
        const logoH = (svgImg.height / svgImg.width) * logoW;

        const userName = `Name: ${filteruser?.fullname || ""}`;
        const userCountry = `Country: ${filteruser?.managingoffice || ""}`;
        const userStatus = `Status: ${declarationData === undefined || declarationData?.status === "draft" || declarationData?.status === ""
            ? "pending"
            : "completed"
          }`;

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const logoMarginTop = -0.25;
          const yLogo = opt.margin[0] - headerHeight + (headerHeight - logoH) / 2 + logoMarginTop;
          pdf.addImage(
            logoPngData,
            "PNG",
            opt.margin[1],
            yLogo,
            logoW,
            logoH
          );

          pdf.setFont("helvetica", "bold");
          pdf.setFontSize(14);
          const titleY = yLogo + logoH / 2;
          pdf.text("BDO East Africa", pageW / 2, titleY, {
            align: "center",
            baseline: "middle",
          });

          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(12);
          const line2Y = yLogo + logoH + 0.2; // 0.2" below logo band

          pdf.text(userName, opt.margin[1], line2Y, {
            align: "left",
            baseline: "middle",
          });
          pdf.text(userCountry, pageW / 2, line2Y, {
            align: "center",
            baseline: "middle",
          });
          pdf.text(userStatus, pageW - opt.margin[1], line2Y, {
            align: "right",
            baseline: "middle",
          });

          const footerY = pageH - opt.margin[0] + 0.2;
          const printedBy = `Printed By: ${userInfo?.userid || ""}`;
          const footerTimestamp = `${moment().format(
            "dddd, DD MMMM YYYY"
          )} - ${moment().format("HH:mm:ss")}`;
          pdf.setFontSize(10);
          pdf.text(printedBy, opt.margin[1], footerY, {
            align: "left",
            baseline: "middle",
          });
          const yearText = `Year of Declaration: ${year ? moment(year).format("YYYY") : ""}`;
          const yearGap = 0.28;
          pdf.text(yearText, opt.margin[1], footerY + yearGap, {
            align: "left",
            baseline: "middle",
          });
          pdf.text(footerTimestamp, pageW - opt.margin[1], footerY, {
            align: "right",
            baseline: "middle",
          });
        }
      })
      .save()
      .finally(() => {
        setIsDownloading(false);
        setLoading(false);
      });
  };

  const handlePrintWithDelay = () => {
    if (data?.status === "submit") {
      setIsPrint(true)
    }
    setLoading(true);
    setTimeout(() => {
      handlePrint();
      setIsPrint(false);
    }, 2000); // 2-second delay
  };

  const { getDeclaration } =
    queryKeys;

  const queryParams = new URLSearchParams();
  queryParams.append("year", year ? moment(year).format("YYYY") : new Date().getFullYear());
  const queryString = queryParams.toString();

  const { key, url } = getDeclaration(filteruser?.userid, queryString);
  const userInfo = useSelector(getUserInfo);
  const userId = userInfo?.userid;
  const { data: declarationDatas, isLoading, refetch } = useFetch(key, url, {
    enabled: !!filteruser?.userid,
  });


  const declarationData = declarationDatas?.response?.response

  useEffect(() => {
    if (selectedYear !== null) {
      refetch();
    }
  }, [selectedYear]);

  useEffect(() => {
    setData(
      {
        "reviewed_clients_list": declarationData?.reviewed_clients_list,
        "inform_directors_about_changes": declarationData?.inform_directors_about_changes,
        "inform_firm_about_client_employment": declarationData?.inform_firm_about_client_employment,
        "treat_client_matters_confidentially": declarationData?.treat_client_matters_confidentially,
        "professional_duties_with_integrity": declarationData?.professional_duties_with_integrity,
        "no_financial_interests_in_clients": declarationData?.no_financial_interests_in_clients,
        "no_loans_or_guarantees_from_clients": declarationData?.no_loans_or_guarantees_from_clients,
        "no_commercial_relationship_with_clients": declarationData?.no_commercial_relationship_with_clients,
        "no_personal_or_family_relationship_with_clients": declarationData?.no_personal_or_family_relationship_with_clients,
        "no_director_or_officer_position_in_clients": declarationData?.no_director_or_officer_position_in_clients,
        "not_audited_client_for_more_than_7_years": declarationData?.not_audited_client_for_more_than_7_years,
        "not_accepted_gifts_or_hospitality_from_clients": declarationData?.not_accepted_gifts_or_hospitality_from_clients,
        "no_direct_or_indirect_charging_of_contingent_fees": declarationData?.no_direct_or_indirect_charging_of_contingent_fees,
        "no_litigation_against_clients": declarationData?.no_litigation_against_clients,
        "Select_as_appropriate": declarationData?.select_as_appropriate,
        "court_judgment_against_debt_last_10_years": declarationData?.court_judgment_against_debt_last_10_years,
        "compromise_arrangement_with_creditors_last_10_years": declarationData?.compromise_arrangement_with_creditors_last_10_years,
        "bankruptcy_declaration_or_order": declarationData?.bankruptcy_declaration_or_order,
        "signed_trust_deed_or_arrangement_with_creditors": declarationData?.signed_trust_deed_or_arrangement_with_creditors,
        "pleaded_or_found_guilty_of_offence": declarationData?.pleaded_or_found_guilty_of_offence,
        "civil_action_against_professional_activities_last_5_years": declarationData?.civil_action_against_professional_activities_last_5_years,
        "disqualified_from_director_or_management": declarationData?.disqualified_from_director_or_management,
        "refused_or_restricted_right_to_carry_on_trade": declarationData?.refused_or_restricted_right_to_carry_on_trade,
        "investigated_for_misconduct_resulting_in_formal_complaint": declarationData?.investigated_for_misconduct_resulting_in_formal_complaint,
        "subject_to_professional_body_disiplinary_procedures": declarationData?.subject_to_professional_body_disiplinary_procedures,
        "reprimanded_or_excluded_from_profession": declarationData?.reprimanded_or_excluded_from_profession,
        "dismissed_or_requested_to_resign_from_employment": declarationData?.dismissed_or_requested_to_resign_from_employment,
        "reprimanded_or_disciplined_by_regulatory_body": declarationData?.reprimanded_or_disciplined_by_regulatory_body,
        "subject_to_court_order_by_regulatory_body": declarationData?.subject_to_court_order_by_regulatory_body,
        "undergoing_investigation_or_disciplinary_procedures": declarationData?.undergoing_investigation_or_disciplinary_procedures,
        "details": declarationData?.details,
        "nature_of_relationship": declarationData?.nature_of_relationship,
        "client_name": declarationData?.client_name,
        "confirm_information": declarationData?.confirm_information,
        "employment_status": declarationData?.employment_status,
        "status": declarationData?.status,
        "time": declarationData?.time,
        "year": declarationData?.year
      }
    );

    const formattedYear = declarationData?.year === "Invalid date"
      ? null
      : moment(declarationData?.year);
    if (declarationData !== undefined) {
      setYear(formattedYear);
    }
    setClientName(declarationData?.client_name);
    setNatureOfRelationship(declarationData?.nature_of_relationship);
  }, [declarationData]);


  const handleSubmitForm = async (value, e, buttonType = typeBtn) => {
    if (buttonType === "submit") {
      try {
        const values = await form.validateFields();

        const requiredFields = [
          'reviewed_clients_list',
          'inform_directors_about_changes',
          'inform_firm_about_client_employment',
          'treat_client_matters_confidentially',
          'professional_duties_with_integrity',
          'no_financial_interests_in_clients',
          'no_loans_or_guarantees_from_clients',
          'no_commercial_relationship_with_clients',
          'no_personal_or_family_relationship_with_clients',
          'no_director_or_officer_position_in_clients',
          'not_audited_client_for_more_than_7_years',
          'not_accepted_gifts_or_hospitality_from_clients',
          'no_direct_or_indirect_charging_of_contingent_fees',
          'no_litigation_against_clients',
          'Select_as_appropriate',
          'court_judgment_against_debt_last_10_years',
          'compromise_arrangement_with_creditors_last_10_years',
          'bankruptcy_declaration_or_order',
          'signed_trust_deed_or_arrangement_with_creditors',
          'pleaded_or_found_guilty_of_offence',
          'civil_action_against_professional_activities_last_5_years',
          'disqualified_from_director_or_management',
          'refused_or_restricted_right_to_carry_on_trade',
          'investigated_for_misconduct_resulting_in_formal_complaint',
          'subject_to_professional_body_disiplinary_procedures',
          'reprimanded_or_excluded_from_profession',
          'dismissed_or_requested_to_resign_from_employment',
          'reprimanded_or_disciplined_by_regulatory_body',
          'subject_to_court_order_by_regulatory_body',
          'undergoing_investigation_or_disciplinary_procedures',
        ];

        const emptyFields = [];
        requiredFields.forEach(field => {
          const value = data?.[field];
          if (!value || value === null || value === 'null' || value === '' || value === false || value === 'false') {
            // Special handling for checkboxes
            if (field === 'confirm_information' || field === 'employment_status') {
              if (value !== true && value !== 'true') {
                emptyFields.push(field);
              }
            } else {
              emptyFields.push(field);
            }
          }
        });

        if (data?.no_personal_or_family_relationship_with_clients === "Disagree") {
          if (!clientName || clientName.trim() === '') {
            emptyFields.push('client_name');
          }
          if (!natureOfRelationship || natureOfRelationship.trim() === '') {
            emptyFields.push('nature_of_relationship');
          }
        }

        const goodReputationFields = [
          'refused_or_restricted_right_to_carry_on_trade',
          'investigated_for_misconduct_resulting_in_formal_complaint',
          'subject_to_professional_body_disiplinary_procedures',
          'reprimanded_or_excluded_from_profession',
          'dismissed_or_requested_to_resign_from_employment',
          'reprimanded_or_disciplined_by_regulatory_body',
          'subject_to_court_order_by_regulatory_body',
          'undergoing_investigation_or_disciplinary_procedures'
        ];

        const hasGoodReputationIssue = goodReputationFields.some(
          field => data?.[field] === "Yes"
        );

        if (hasGoodReputationIssue) {
          if (!data?.details || data?.details.trim() === '') {
            emptyFields.push('details');
          }
        }

        if (emptyFields.length > 0) {
          console.log('Empty fields:', emptyFields);
          message.error('Please fill in all required fields before submitting');
          // Scroll to first error
          form.scrollToField(emptyFields[0]);
          return;
        }

      } catch (errorInfo) {
        message.error('Please fill in all required fields before submitting');
        return;
      }
    }
    setLoader(buttonType === "draft" ? true : false);
    setsubmitbtnLoader(buttonType === "submit" ? true : false);
    const now = new Date();
    const currentDateTime = now.toISOString();
    const { code } = await CALL_API(
      `declaration/${filteruser?.userid}`,
      "post",
      {
        "userId": filteruser?.userid || null,
        "name": filteruser?.fullname || null,
        "designation": filteruser?.designation || null,
        "institutename": filteruser?.institutename || null,
        "managingoffice": filteruser?.managingoffice || null,
        "personemailaddress": filteruser?.person_email_address || null,
        "companyname": filteruser?.companyname || "",
        "country": filteruser?.country || "",
        "independenceform": "yes" || null,
        "year": year ? moment(year).format("YYYY") : null,
        "reviewed_clients_list": data?.reviewed_clients_list || null,
        "inform_directors_about_changes": data?.inform_directors_about_changes || null,
        "inform_firm_about_client_employment": data?.inform_firm_about_client_employment || null,
        "treat_client_matters_confidentially": data?.treat_client_matters_confidentially || null,
        "professional_duties_with_integrity": data?.professional_duties_with_integrity || null,
        "no_financial_interests_in_clients": data?.no_financial_interests_in_clients || null,
        "no_loans_or_guarantees_from_clients": data?.no_loans_or_guarantees_from_clients || null,
        "no_commercial_relationship_with_clients": data?.no_commercial_relationship_with_clients || null,
        "no_personal_or_family_relationship_with_clients": data?.no_personal_or_family_relationship_with_clients || null,
        "no_director_or_officer_position_in_clients": data?.no_director_or_officer_position_in_clients || null,
        "not_audited_client_for_more_than_7_years": data?.not_audited_client_for_more_than_7_years || null,
        "not_accepted_gifts_or_hospitality_from_clients": data?.not_accepted_gifts_or_hospitality_from_clients || null,
        "no_direct_or_indirect_charging_of_contingent_fees": data?.no_direct_or_indirect_charging_of_contingent_fees || null,
        "no_litigation_against_clients": data?.no_litigation_against_clients || null,
        "client_name": clientName || null,
        "nature_of_relationship": natureOfRelationship || null,
        "Select_as_appropriate": data?.Select_as_appropriate || null,
        "court_judgment_against_debt_last_10_years": data?.court_judgment_against_debt_last_10_years || null,
        "compromise_arrangement_with_creditors_last_10_years": data?.compromise_arrangement_with_creditors_last_10_years || null,
        "bankruptcy_declaration_or_order": data?.bankruptcy_declaration_or_order || null,
        "signed_trust_deed_or_arrangement_with_creditors": data?.signed_trust_deed_or_arrangement_with_creditors || null,
        "pleaded_or_found_guilty_of_offence": data?.pleaded_or_found_guilty_of_offence || null,
        "civil_action_against_professional_activities_last_5_years": data?.civil_action_against_professional_activities_last_5_years || null,
        "disqualified_from_director_or_management": data?.disqualified_from_director_or_management || null,
        "refused_or_restricted_right_to_carry_on_trade": data?.refused_or_restricted_right_to_carry_on_trade || null,
        "investigated_for_misconduct_resulting_in_formal_complaint": data?.investigated_for_misconduct_resulting_in_formal_complaint || null,
        "subject_to_professional_body_disiplinary_procedures": data?.subject_to_professional_body_disiplinary_procedures || null,
        "reprimanded_or_excluded_from_profession": data?.reprimanded_or_excluded_from_profession || null,
        "dismissed_or_requested_to_resign_from_employment": data?.dismissed_or_requested_to_resign_from_employment || null,
        "reprimanded_or_disciplined_by_regulatory_body": data?.reprimanded_or_disciplined_by_regulatory_body || null,
        "subject_to_court_order_by_regulatory_body": data?.subject_to_court_order_by_regulatory_body || null,
        "undergoing_investigation_or_disciplinary_procedures": data?.undergoing_investigation_or_disciplinary_procedures || null,
        "details": data?.details || null,
        "status": buttonType || null,
        "confirm_information": data?.confirm_information || "false",
        "employment_status": data?.employment_status || "false",
        "clientId": clientId || null,
        "time": currentDateTime || null
      }
    );

    if (code === STATUS_CODE.SUCCESS) {
      const successMessage = buttonType === "submit" ? "Submitted Successfully" : "Updated Successfully";
      message.success(successMessage)
      refetch()
    }
    setLoader(false);
    setsubmitbtnLoader(false);
  };

  const tabledata = [
    {
      client_name: "",
      nature_of_relationship: ""
    }
  ]

  const columns = [
    {
      title: "Client Name",
      dataIndex: "",
      key: "client_name",
      align: "center",
      width: "50%",
      render: (text, record, index) => {
        return (
          <Form.Item
            label=""
            name="" // Use a unique name for each item
            rules={[
              { required: true, message: "Please input your client name!" },
            ]}
          >
            <Input.TextArea
              bordered={false}
              placeholder="Enter"
              rows={2}
              value={clientName}
              style={{
                resize: "none",
              }}
              onKeyDown={(e) => {
                const isValidCharacter = /[A-Za-z\s]/.test(e.key); if (!isValidCharacter) { e.preventDefault(); }
              }}
              onPaste={(e) => {
                const pastedData = e.clipboardData.getData('text');
                if (!/^[A-Za-z\s]*$/.test(pastedData)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => setClientName(e.target.value)} // Update the change handler
            />
          </Form.Item>
        );
      },
    },
    {
      title: "Nature of relationship",
      dataIndex: "",
      key: "nature_of_relationship",
      align: "center",
      width: "50%",
      render: (text) => {
        return (
          <Form.Item
            label=""
            name="test"
            rules={[
              {
                required: true,
                message: "Please input your nature of relationship!",
              },
            ]}
          >
            <Input.TextArea
              bordered={false}
              placeholder="Enter"
              rows={2}
              value={natureOfRelationship}
              style={{
                resize: "none",
                border: "none",
              }}
              onKeyDown={(e) => {
                const isValidCharacter = /[A-Za-z\s]/.test(e.key); if (!isValidCharacter) { e.preventDefault(); }
              }}
              onPaste={(e) => {
                const pastedData = e.clipboardData.getData('text');
                if (!/^[A-Za-z\s]*$/.test(pastedData)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => setNatureOfRelationship(e.target.value)}
            />
          </Form.Item>
        );
      },
    },
  ];

  const { DeclarationForm } = getDeclarationJson(tabledata, columns, handleSubmitForm, handlePrintWithDelay, loading, data, loader, type, setTypeBtn, filteruser, submitbtnLoader, isPrint);


  const handleFormChange = (e) => {
    const { name, type, value, checked, id } = e.target;

    if (type === 'checkbox') {
      setData((prevData) => ({
        ...prevData,
        [id]: checked,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }

  };
  const getStatusText = () => {
    if (declarationData === undefined || declarationData?.status === "draft" || declarationData?.status === "") {
      return "pending";
    }
    return "completed";
  };

  return (
    <StyledDeclaration>
      <Spin spinning={loading}>
        <div className='d-flex align-items-center  gap-3'>
          <h6>Name: {filteruser?.fullname}</h6>
          <div ref={containerRef}>

            <DatePicker
              className="w-100"
              picker='year'
              value={year ? moment(year) : null}
              format="YYYY"
              placeholder="Select date"
              getPopupContainer={() => containerRef.current}
              onChange={(date) => {
                setYear(date ? moment(date).startOf('year') : null)
                setSelectedYear(date ? moment(date).startOf('year') : null)
              }}
              disabledDate={(current) => current && current.year() > new Date().getFullYear()}
            />
          </div>

          <span className='bg-info p-1 px-2'>{getStatusText()}</span>



        </div>
        <div ref={printComponentRef} className='p-2'>
          <div className="pdf-content">
            <br />
            <h6>Section A: Annual Independence Declaration:</h6>
            <p>The audit firm and the individual auditor should be free in both fact and appearance from personal, external, and organizational impairments to independence. Auditors are independent whey they can carry out their work freely and objectively. Independence permits auditors to render the impartial and unbiased judgment essential to the proper conduct of audits.</p>
            <p>We expect our auditors to maintain independence of mental attitude in the conduct of all assigned work; to be objective, fair, and impartial, and to conduct themselves so that auditees and third parties will see our office in this way. Each staff member must promptly notify the Audit Manager, or higher, in writing concerning an audit, or that might lead others to question it. If a staff member has any doubt about whether a situation may be impaired, he or she should resolve the question in favour of disclosure.</p>
            <p>In line with the above, I confirm the following:</p>
            <GridBuilder
              formStructureJson={DeclarationForm}
              handleChange={handleFormChange}
              formSubmit={handleSubmitForm}
              initialValues={data}
              disabled={(data?.status === undefined || data?.status === "draft" || data?.status === "") && type !== "Declaration" ? false : true}
            />
          </div>
        </div>
      </Spin>
    </StyledDeclaration>
  )
}

export default Declaration